import { SimpleForm as RASimpleForm, SaveButton, Toolbar } from "react-admin";

const MyToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton type="button" />
  </Toolbar>
);

export const SimpleForm = ({ children, ...props }) => {
  return (
    <RASimpleForm toolbar={<MyToolbar />} sanitizeEmptyValues {...props}>
      {children}
    </RASimpleForm>
  );
};
